export default __webpack_public_path__ + "954c13fcd19f6c6ef19f5fce7b1d0779.svg";